import { render, staticRenderFns } from "./PromotionPlan.vue?vue&type=template&id=6a053f5e&scoped=true&"
import script from "./PromotionPlan.vue?vue&type=script&lang=js&"
export * from "./PromotionPlan.vue?vue&type=script&lang=js&"
import style0 from "./PromotionPlan.vue?vue&type=style&index=0&id=6a053f5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a053f5e",
  null
  
)

export default component.exports